<template>
  <div style="margin-right: 1em;">
    <div class="form-row">
      <div class="form-group col-6">
        <label 
          class="required"
          style="margin-top: 1em;"
        >
          {{ $t('resource.format.label') }}
        </label>
        <p class="label-help">
          {{ $t('resource.format.help') }}
        </p>
        <ValidatedFileFormatSelector
          :required="resource.isNotEmpty()"
          validation-name="Format Href"
          @select="selectFormat($event)"
        />
      </div>
    </div>
    <div class="form-row">
      <div class="form-group col">
        <label 
          class="required"
          style="margin-top: 1em;"
        >
          URL
        </label>
        <p>{{ $t('resource.url.help') }}</p>
        <p v-if="form.format!=null && form.format.codename.indexOf('ogc-') !== -1">
          Si c'est une couche OGC, renseignez l'URL du service GetCapabilities
        </p>
        <ValidationProvider
          v-slot="{ classes, errors }"
          name="URL"
          :rules="`${resource.isNotEmpty() ? 'required' : ''}`"
        >
          <div
            class="control"
            :class="resource.isNotEmpty() ? classes : ''"
          >
            <input
              v-model="resource.href.href"
              v-sanitize
              class="form-control"
              type="text"
              placeholder="https://"
            >
            <span class="form-errors">{{ errors[0] }}</span>
          </div>
        </ValidationProvider>
      </div>
    </div>
  </div>
</template>

<script>

import ValidatedFileFormatSelector from '@/common/components/ValidatedFileFormatSelector.vue';
import { ValidationProvider, extend, configure } from 'vee-validate';
import { required } from 'vee-validate/dist/rules';

extend('required', {
  ...required,
  message: 'Ce champ est requis'
});
configure({
  classes: {
    valid: 'is-valid',
    invalid: 'is-invalid'
  }
});

export default {
  name: 'HrefCreator',

  components: {
    ValidatedFileFormatSelector,
    ValidationProvider
  },

  props: {
    required: {
      type: Boolean,
      default: true
    },
    resource: {
      type: Object,
      default: () => ({})
    },
  },

  data() {
    return {
      form: {
        type: 'href',
        format: null,
        // scheduler: null,
        href: null
      }
    };
  },


  watch: {

   
  },

  created() {
    if (!this.resource) this.resource = {};
    this.$set(this.resource, 'type', 'href');
    if (!this.resource.href) this.$set(this.resource, 'href', {});
  },

  methods: {

    selectFormat(format) {
      this.form.format = format;
      this.$set(this.resource.href, 'dataformat', format.codename);
    },
   
  }
};
</script>
